import React from "react";
import LoaderComponent from "../../../../../../../components/LoaderComponent/LoaderComponent";

const Loader = ({text = "In Progress..."}) => {
  return (
    <div
      className="absolute inset-0 z-[100] flex flex-col items-center justify-center gap-4 bg-white/90"
      aria-busy="true"
      aria-live="polite"
    >
      <LoaderComponent />

      <span className="mb-[38px] text-sm text-gray-600">
        {text}
      </span>
    </div>
  );
};

export default Loader;
